var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "40px",
    viewBox: "0 -960 960 960",
    width: "40px",
    fill: "#BB271A",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344.33-437.67h42V-521h43q17.79 0 30.4-12.35 12.6-12.35 12.6-29.65v-41.67q0-17.79-12.6-30.39-12.61-12.61-30.4-12.61h-85v210Zm42-125.33v-41.67h43V-563h-43Zm127.34 125.33h84.01q17.32 0 30.32-12.17T641-480v-124.67q0-17.79-13.09-30.39-13.09-12.61-29.91-12.61h-84.33v210Zm42-42.33v-124.67H598V-480h-42.33Zm127.66 42.33h42V-521h41.34v-42h-41.34v-41.67h41.34v-43h-83.34v210Zm-397 244.34q-34.15 0-59.07-25.14-24.93-25.14-24.93-58.86V-816q0-33.73 24.93-58.86Q252.18-900 286.33-900H825q33.72 0 58.86 25.14Q909-849.73 909-816v538.67q0 33.72-25.14 58.86T825-193.33H286.33Zm0-84H825V-816H286.33v538.67ZM135.67-42.67q-34.15 0-59.08-25.13-24.92-25.14-24.92-58.87v-622.66h84v622.66h622.66v84H135.67ZM286.33-816v538.67V-816Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdfIcon.f1bccfd970cda469c8c0aaa9b257ffdb.svg";
export { ForwardRef as ReactComponent };